import { MoveWithTwoCoords } from './MoveWithTwoCoords';
import { Ordinal } from './Ordinal';
import { RulesFailure } from './RulesFailure';
export class MoveCoordToCoord extends MoveWithTwoCoords {
    constructor(start, end) {
        super(start, end);
        if (start.equals(end))
            throw new Error(RulesFailure.MOVE_CANNOT_BE_STATIC());
    }
    getDistance() {
        return this.getStart().getLinearDistanceToward(this.getEnd(), false);
    }
    getDirection() {
        return Ordinal.factory.fromMove(this.getStart(), this.getEnd());
    }
    getStart() {
        return this.getFirst();
    }
    getEnd() {
        return this.getSecond();
    }
    getMovedOverCoords() {
        return this.getStart().getAllCoordsToward(this.getEnd());
    }
    getJumpedOverCoords() {
        return this.getStart().getCoordsToward(this.getEnd());
    }
    equals(other) {
        if (this === other)
            return true;
        if (this.getStart().equals(other.getStart()) === false)
            return false;
        return this.getEnd().equals(other.getEnd());
    }
    toString() {
        const start = this.getStart().toString();
        const end = this.getEnd().toString();
        return `${start} -> ${end}`;
    }
}
